import React from "react";
import "./TeamPage.css";

export default function TeamCard(props) {
    const details = props.details;
    const member_type = props.member_type;
    return (
        <div className={`team-card ${member_type}`} >
            <div className="team-card-image">
                <img src={details.image} alt={details.name} />
                <div className="team-card-overlay">
                    <h3 className="team-card-name">{details.name}</h3>
                    <p className="team-card-role">{details.role}</p>
                </div> 
            </div>
        </div>
    );
}
